module.exports = __webpack_public_path__ + "static/media/crow_eat_rotinew.09d2e98a.gif";